import React, { useEffect, useRef, useState } from 'react'

function RemoteSvgWithJS({ url = '', classNames = '', svgContent = '' }) {
  const iframeRef = useRef(null)
 
  useEffect(() => {
    function handleMessage(event) {
      if (
        event.data &&
        event.data.svgHeight &&
        iframeRef.current &&
        url === event.data.url
      ) {
        iframeRef.current.style.height = event.data.svgHeight + 'px'
        iframeRef.current.style.width = event.data.svgWidth + 'px'
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  useEffect(() => {
    if (!svgContent || !iframeRef.current) return

    const node = iframeRef.current
    let observer = null

    if (node) {
      observer = new window.IntersectionObserver(
        ([entry]) => {
          const target = entry.target
          if (entry.isIntersecting) {
            if (target) {
              target.srcdoc = iframeSrcDoc
            }
          }
        },
        { threshold: 0.2 }
      )

      observer.observe(node)
    }

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [svgContent])

  const nonce = window?.digitalData?.page?.pageInfo?.nonce || ''

  const svgContentWithNonce = nonce
    ? svgContent.replace(/<script\b/g, `<script nonce="${nonce}"`)
    : svgContent

  const iframeSrcDoc = svgContent
    ? `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body, html {
              margin: 0;
              padding: 0;
              overflow: hidden;
              background: transparent;
            }
            svg {
              display: block;
            }
          </style>
        </head>
        <body>
          ${svgContentWithNonce}
          <script ${nonce ? `nonce="${nonce}"` : ''}>
          function sendHeight() {
            var svg = document.querySelector('svg');
            if (svg) {
              var height = svg.getBoundingClientRect().height;
              var width = svg.getBoundingClientRect().width;
              window.parent.postMessage({ svgHeight: height, svgWidth: width, url: '${url}' }, '*');
            }
          }
          window.onload = sendHeight;
          window.onresize = sendHeight;
        </script>
        </body>
      </html>
    `
    : ''

  return (
    <div className={`RemoteSvgWithJS ${classNames}`} data-url={url}>
      <iframe
        ref={iframeRef}
        title="Remote SVG Viewer"
        sandbox="allow-scripts"
        srcDoc={iframeSrcDoc}
        width="100%"
        style={{ border: 'none', maxWidth: '100%' }}
      />
    </div>
  )
}

export default RemoteSvgWithJS
